<template>
  <div class="MyLeaveMessageViewContainer box">
    <template v-for="l in list" :key="`l_${l.id}`">
      <div class="colFlex wbg pd12 box brd6 mb12 smallFont">
        <nut-row class="bothCenter">
          <nut-col :span="6" class="leftCenter">
            <span>{{ l.state == 'UN_REPLY' ? '待回复' : '已回复' }}</span>
          </nut-col>
          <nut-col :span="18" class="rightCenter">
            <span>{{ l.createdTime }}</span>
          </nut-col>
        </nut-row>
        <nut-row style="color: gray" class="colFlex mt6 smallFont">
          <span>您的留言：{{ l.content }}</span>
          <template v-for="r in l.leaveMessageReplies" :key="`r_${l.id}_${r.id}`">
            <span>工作人员回复：{{ r.content }} 【{{r.createdTime}}】</span>
          </template>
        </nut-row>
      </div>
    </template>
    <template v-if="!list || list.length < 1">
      <nut-row class="colFlex mt32 bothCenter">
        <img  style="width: 40%" src="https://cdn.waityou.online/5be1d65f-64a0-a13b-125d-255257564901.png"/>
        <span style="color: lightgrey">暂无数据</span>
      </nut-row>
    </template>
    <img src="https://cdn.waityou.online/a7b3dfed-fa02-5145-b93f-7bf65a065dec.svg"
         @click="$router.push('/leave/message')"
         class="sqr40 pd10 wbg brd80" style="position: fixed;right: 20px;bottom: 150px">
  </div>
</template>

<script>

import api from "@/api";

export default {
  name: "MyLeaveMessageView",
  components: {},
  data() {
    return {
      list: null
    }
  },
  methods: {
    init() {
      api.getMyLeaveMessage()
          .then(ret => {
            this.list = ret;
          })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.MyLeaveMessageViewContainer {
  display: flex;
  flex-direction: column;
  background-color: #F4F6F9;
  padding: 16px;
  min-height: calc(100vh - 32px);

  .submitBtn {
    border: none;
    color: white;
    width: 160px;
    height: 44px;
    background: #2F438C;
    border-radius: 12px;
  }

  textarea:focus {
    outline: none;
  }
}
</style>